import React from 'react';
import SongLinks from './SongLinks';
import cover from "../assets/coverart/paradies.jpg"


export const Paradies = () => {    

    return (
        <SongLinks 
        title={"Ein neues Paradies, oder: die Bäume waren mal Zäune"} 
        coverArt={cover} 
        spotifyLink={"https://open.spotify.com/album/4EIl4te7xpHEZPsAckvnVU"}
        spotifyPresaveLink={"https://add-it.feiyr.com/zebrablau/Ein%20neues%20Paradies%2C%20oder%3A%20Die%20Z%C3%A4une%20waren%20mal%20B%C3%A4ume"}
        appleMusicLink={"https://music.apple.com/de/song/ein-neues-paradies-oder-die-z%C3%A4une-waren-mal-b%C3%A4ume/1848380230"} 
        appleMusicPresaveLink={undefined}
        youtubeMusicLink={"https://music.youtube.com/watch?v=tocKALEqyBo"}
        youtubeLink={"https://www.youtube.com/watch?v=KG69Z_aOrbU"}
        tidalLink={"https://tidal.com/album/469184038"}
        amazonMusicLink={"https://www.amazon.de/music/player/albums/B0FXN2H64Z"}
        bandcampLink={"https://mondwild.bandcamp.com/track/ein-neues-paradies-oder-die-z-une-waren-mal-b-ume"}
        releaseDate={"2025-11-14T00:00:00+01:00"}/>
    );
}